export * from './gutachten-list.component';
export * from './gutachten-list.component.module';